export default __webpack_public_path__ + "static/media/customerIcon.c867d3f8.png";